import React from "react";
import "./footer.scss";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
const Footer = () => {
  const { hash } = useLocation();
  const isActive = (iHash) => hash === iHash;
  return (
    <>
      <section className="footermain">
        <img
          src="/assets/footermain.svg"
          alt="footerimg"
          className="footerimg"
        />
        <div className="custom-container">
          <div className="footerinner">
            <div className="footerleft">
              <a href="/">
                <img src="/logo.svg" alt="logoimg" className="logoimg" />
              </a>
              <div className="sociallinks">
                <a href="https://t.me/Luckify_official" className="innerlink" target="_blank">
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <path d="M1.71862 10.7624C8.42949 7.23439 12.9045 4.90848 15.1435 3.78472C21.5365 0.576142 22.8649 0.0187791 23.7307 0.000178427C23.9212 -0.0036732 24.347 0.0532744 24.6228 0.323326C24.8557 0.551352 24.9197 0.859384 24.9504 1.07558C24.9811 1.29177 25.0192 1.78427 24.9889 2.16909C24.6424 6.56138 23.1434 17.2203 22.3808 22.1398C22.0581 24.2214 21.4227 24.9193 20.8076 24.9876C19.4707 25.1361 18.4556 23.9216 17.1608 22.8974C15.1348 21.2948 13.9901 20.2972 12.0235 18.7334C9.75066 16.9261 11.224 15.9328 12.5193 14.3094C12.8583 13.8846 18.7484 7.41993 18.8624 6.83348C18.8767 6.76014 18.8899 6.48674 18.7553 6.34238C18.6207 6.19802 18.422 6.24738 18.2787 6.28665C18.0754 6.3423 14.8388 8.92374 8.56858 14.031C7.64985 14.7922 6.8177 15.1631 6.07212 15.1437C5.25018 15.1223 3.6691 14.5829 2.49372 14.1219C1.05207 13.5564 -0.0937162 13.2574 0.00605648 12.2971C0.0580242 11.7969 0.628879 11.2853 1.71862 10.7624Z" fill="#737373" />
                  </svg>
                </a>
                {/* <a href="" className="innerlink">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      d="M12.5049 6.88452C9.39941 6.88452 6.89453 9.3894 6.89453 12.4949C6.89453 15.6003 9.39941 18.1052 12.5049 18.1052C15.6104 18.1052 18.1152 15.6003 18.1152 12.4949C18.1152 9.3894 15.6104 6.88452 12.5049 6.88452ZM12.5049 16.1423C10.498 16.1423 8.85742 14.5066 8.85742 12.4949C8.85742 10.4832 10.4932 8.84741 12.5049 8.84741C14.5166 8.84741 16.1523 10.4832 16.1523 12.4949C16.1523 14.5066 14.5117 16.1423 12.5049 16.1423ZM19.6533 6.65503C19.6533 7.38257 19.0674 7.96362 18.3447 7.96362C17.6172 7.96362 17.0361 7.37769 17.0361 6.65503C17.0361 5.93237 17.6221 5.34644 18.3447 5.34644C19.0674 5.34644 19.6533 5.93237 19.6533 6.65503ZM23.3691 7.98315C23.2861 6.23022 22.8857 4.67749 21.6016 3.39819C20.3223 2.1189 18.7695 1.71851 17.0166 1.63062C15.21 1.52808 9.79492 1.52808 7.98828 1.63062C6.24023 1.71362 4.6875 2.11401 3.40332 3.39331C2.11914 4.67261 1.72363 6.22534 1.63574 7.97827C1.5332 9.78491 1.5332 15.2 1.63574 17.0066C1.71875 18.7595 2.11914 20.3123 3.40332 21.5916C4.6875 22.8708 6.23535 23.2712 7.98828 23.3591C9.79492 23.4617 15.21 23.4617 17.0166 23.3591C18.7695 23.2761 20.3223 22.8757 21.6016 21.5916C22.8809 20.3123 23.2812 18.7595 23.3691 17.0066C23.4717 15.2 23.4717 9.78979 23.3691 7.98315ZM21.0352 18.9451C20.6543 19.9021 19.917 20.6394 18.9551 21.0251C17.5146 21.5964 14.0967 21.4646 12.5049 21.4646C10.9131 21.4646 7.49023 21.5916 6.05469 21.0251C5.09766 20.6443 4.36035 19.907 3.97461 18.9451C3.40332 17.5046 3.53516 14.0867 3.53516 12.4949C3.53516 10.9031 3.4082 7.48022 3.97461 6.04468C4.35547 5.08765 5.09277 4.35034 6.05469 3.9646C7.49512 3.39331 10.9131 3.52515 12.5049 3.52515C14.0967 3.52515 17.5195 3.39819 18.9551 3.9646C19.9121 4.34546 20.6494 5.08276 21.0352 6.04468C21.6064 7.48511 21.4746 10.9031 21.4746 12.4949C21.4746 14.0867 21.6064 17.5095 21.0352 18.9451Z"
                      fill="#737373"
                    />
                  </svg>
                </a>
                <a href="" className="innerlink">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1029_2095)">
                      <path
                        d="M24.6094 12.5C24.6094 5.81055 19.1895 0.390625 12.5 0.390625C5.81055 0.390625 0.390625 5.81055 0.390625 12.5C0.390625 18.5439 4.81885 23.5537 10.6079 24.4629V16.0005H7.53174V12.5H10.6079V9.83203C10.6079 6.79736 12.4146 5.12109 15.1816 5.12109C16.5068 5.12109 17.8926 5.35742 17.8926 5.35742V8.33594H16.3652C14.8613 8.33594 14.3921 9.26953 14.3921 10.2271V12.5H17.7505L17.2134 16.0005H14.3921V24.4629C20.1812 23.5537 24.6094 18.5439 24.6094 12.5Z"
                        fill="#737373"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1029_2095">
                        <rect width="25" height="25" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <a href="" className="innerlink">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      d="M21.875 1.5625H3.12012C2.26074 1.5625 1.5625 2.27051 1.5625 3.13965V21.8604C1.5625 22.7295 2.26074 23.4375 3.12012 23.4375H21.875C22.7344 23.4375 23.4375 22.7295 23.4375 21.8604V3.13965C23.4375 2.27051 22.7344 1.5625 21.875 1.5625ZM8.17383 20.3125H4.93164V9.87305H8.17871V20.3125H8.17383ZM6.55273 8.44727C5.5127 8.44727 4.67285 7.60254 4.67285 6.56738C4.67285 5.53223 5.5127 4.6875 6.55273 4.6875C7.58789 4.6875 8.43262 5.53223 8.43262 6.56738C8.43262 7.60742 7.59277 8.44727 6.55273 8.44727ZM20.3271 20.3125H17.085V15.2344C17.085 14.0234 17.0605 12.4658 15.4004 12.4658C13.7109 12.4658 13.4521 13.7842 13.4521 15.1465V20.3125H10.21V9.87305H13.3203V11.2988H13.3643C13.7988 10.4785 14.8584 9.61426 16.4355 9.61426C19.7168 9.61426 20.3271 11.7773 20.3271 14.5898V20.3125Z"
                      fill="#737373"
                    />
                  </svg>
                </a>
                <a href="" className="innerlink">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      d="M23.8566 6.77427C23.5839 5.7478 22.7807 4.93938 21.7609 4.66503C19.9124 4.1665 12.5 4.1665 12.5 4.1665C12.5 4.1665 5.08767 4.1665 3.2391 4.66503C2.21927 4.93942 1.41606 5.7478 1.14344 6.77427C0.648132 8.63482 0.648132 12.5167 0.648132 12.5167C0.648132 12.5167 0.648132 16.3985 1.14344 18.2591C1.41606 19.2856 2.21927 20.0603 3.2391 20.3346C5.08767 20.8332 12.5 20.8332 12.5 20.8332C12.5 20.8332 19.9123 20.8332 21.7609 20.3346C22.7807 20.0603 23.5839 19.2856 23.8566 18.2591C24.3519 16.3985 24.3519 12.5167 24.3519 12.5167C24.3519 12.5167 24.3519 8.63482 23.8566 6.77427ZM10.0757 16.0411V8.99224L16.271 12.5168L10.0757 16.0411Z"
                      fill="#737373"
                    />
                  </svg>
                </a> */}
              </div>
            </div>
            <div className="footerright">
              <div className="mainlinksdiv">
                <h6 className="mainhead">Luckify</h6>
                <HashLink
                  to="#home"
                  style={
                    isActive("#home")
                      ? {
                        color: "#B078FF",
                      }
                      : {}
                  }
                  className="mainlinks"
                >
                  Home
                </HashLink>
                <HashLink
                  to="#about"
                  style={
                    isActive("#about")
                      ? {
                        color: "#B078FF",
                      }
                      : {}
                  }
                  className="mainlinks"
                >
                  About
                </HashLink>
                <HashLink
                  to="#how"
                  style={
                    isActive("#how")
                      ? {
                        color: "#B078FF",
                      }
                      : {}
                  }
                  className="mainlinks"
                >
                  How it Works?
                </HashLink>
                <HashLink
                  to="#why"
                  style={
                    isActive("#why")
                      ? {
                        color: "#B078FF",
                      }
                      : {}
                  }
                  className="mainlinks"
                >
                  Why it Matters?
                </HashLink>
                <HashLink
                  to="#luck"
                  style={
                    isActive("#luck")
                      ? {
                        color: "#B078FF",
                      }
                      : {}
                  }
                  className="mainlinks"
                >
                  $LUCK
                </HashLink>
                <HashLink
                  to="#usecases"
                  style={
                    isActive("#usecases")
                      ? {
                        color: "#B078FF",
                      }
                      : {}
                  }
                  className="mainlinks"
                >
                  Use Cases
                </HashLink>
              </div>
              <div className="mainlinksdiv">
                <h6 className="mainhead">Resources</h6>
                <a
                  href="https://app.luckify.bet/"
                  target="_blank"
                  className="mainlinks"
                >
                  Launch App
                </a>
                <a href="/lightpaper.pdf" target="_blank" className="mainlinks">
                  Lightpaper
                </a>
              </div>
            </div>
          </div>
          <div className="brdr"></div>
          <div className="lowerfooter">
            <div className="lowerleft">
              <a href="/privacy-and-policy" className="lowerlink">
                Privacy Policy
              </a>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="4"
                height="5"
                viewBox="0 0 4 5"
                fill="none"
              >
                <circle cx="2" cy="2.5" r="2" fill="#D9D9D9" />
              </svg>
              <a href="/terms-and-conditions" className="lowerlink">
             Terms & Conditions
              </a>
            </div>
            <div>
              <h4>By Gems Labs Asia Ltd</h4>
            </div>
            <p className="lowerrightpara">© 2025. All rights reserved</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
